var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.ProgramCartridge = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  var ProgramCartridge = function ProgramCartridge(_ref) {
    var className = _ref.className,
        fullWidth = _ref.fullWidth,
        logo = _ref.logo,
        logoHeight = _ref.logoHeight,
        logoTitle = _ref.logoTitle,
        logoWidth = _ref.logoWidth,
        text = _ref.text,
        url = _ref.url;
    return /*#__PURE__*/_react.default.createElement("a", {
      className: (0, _classnames.default)('program-cartridge', className, {
        'full-width': fullWidth
      }),
      href: url
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "program-cartridge__text",
      style: {
        height: logoHeight
      }
    }, text), /*#__PURE__*/_react.default.createElement("img", {
      className: "program-cartridge__logo",
      src: logo,
      alt: logoTitle,
      width: logoWidth,
      height: logoHeight,
      style: {
        height: logoHeight
      },
      "aria-hidden": true
    }));
  };

  ProgramCartridge.propTypes = {
    className: _propTypes.default.string,
    fullWidth: _propTypes.default.bool,
    logo: _propTypes.default.string.isRequired,
    logoHeight: _propTypes.default.number,
    logoTitle: _propTypes.default.string.isRequired,
    logoWidth: _propTypes.default.number,
    text: _propTypes.default.string.isRequired,
    url: _propTypes.default.string
  };
  ProgramCartridge.defaultProps = {
    className: '',
    fullWidth: false,
    logo: '',
    logoHeight: 59,
    logoTitle: '',
    logoWidth: 105,
    text: '',
    url: ''
  };
  var _default = ProgramCartridge;
  _exports.default = _default;
});